export const DOCK_PATHS = {
  home: "/",
  clients: "/clients",
  advicePortal: "/advice-portal",
  orderInstructions: "/order-instructions",
  quantAdmin: "/quant-admin",
  admin: "/admin",
  settings: "/settings",
  fa: "/fa",
} as const;

export const ADVICE_PORTAL_NEW = `${DOCK_PATHS.advicePortal}/new-advice`;

export const ADVICE_PORTAL_NEW_CLIENT = `${DOCK_PATHS.advicePortal}/new-client`;

export const FA_TABS = {
  contacts: `${DOCK_PATHS.fa}/contacts`,
  accountOpenings: `${DOCK_PATHS.fa}/account-openings`,
} as const;

export const ADVICE_PORTAL_RECORDS = `${DOCK_PATHS.advicePortal}/records`;

export type FaTab = keyof typeof FA_TABS;

export function isVisibleDockApplicationPage(pathname: string): boolean {
  return APPLICATION_ROOTS.some((path) => pathname === path || pathname.startsWith(`${path}/`));
}

export function isRecordPaneRoute(pathname: string): boolean {
  return pathname === ADVICE_PORTAL_NEW || pathname.startsWith(`${ADVICE_PORTAL_RECORDS}/`);
}

export function clientPath(clientId: string): string {
  return `${DOCK_PATHS.clients}/${encodeURIComponent(clientId)}`;
}

export function faTabOf(segment: string | undefined): FaTab | null {
  const path = `${DOCK_PATHS.fa}/${segment}`;
  return (Object.keys(FA_TABS) as FaTab[]).find((tab) => FA_TABS[tab] === path) ?? null;
}

export function faContactsFor(focus: { kind: "individual" | "corporation"; id: string }): string {
  return `${FA_TABS.contacts}?${focus.kind}=${encodeURIComponent(focus.id)}`;
}

const APPLICATION_ROOTS = [
  DOCK_PATHS.clients,
  DOCK_PATHS.advicePortal,
  DOCK_PATHS.orderInstructions,
  DOCK_PATHS.quantAdmin,
  DOCK_PATHS.admin,
  DOCK_PATHS.settings,
  DOCK_PATHS.fa,
];
